import React, {Component} from 'react';
import { connect } from 'react-redux';
import DashboardAppSection from "../DashboardAppSection";
import DashboardButton from "../button/DashboardButton";
import HrbTranslate from "../../language/HrbTranslate";
import {getConfiguration} from "../../../store/rootReducer";
import diyImage from '../../../resources/images/diy_comp.png'
import "./DiyDashboardSection.scss"
import externalApps from '../../../services/externalApps/ExternalApps';
import auth from '../../../services/auth/AuthProvider';

class DiyDashboardSection extends Component {

  render() {
    let taxYearApps = externalApps.getSupportedDiyApps().map((app, index) => {
      let buttonContent = "dashboard.diy_start_past_year_return";

      let isCurrentTaxYear = index === 0;
      if (isCurrentTaxYear) {
        buttonContent = "dashboard.diy_start_current_year_return";
      }
      return app.appName ? (
        <DashboardButton key={app.taxYear} onClick={() => auth.redirect(app.appName, 'dashboard')}>
            <HrbTranslate text={buttonContent} params={{ "taxyear": app.taxYear }} />
        </DashboardButton>
      ) : null;
    });

    var img = (
      <div className="hrb-diy-dashboard-img-container"><img src={diyImage} width="38px" height="38px" alt='' /></div>
    );
    return (
        <div>
          <DashboardAppSection header="dashboard.diy_software_heading" sectionHelpLink="links.online_tax_software" img={img}>
            {taxYearApps}
          </DashboardAppSection>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    configuration: getConfiguration(state)
  }
};

export default connect(
    mapStateToProps,
)(DiyDashboardSection);